/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/theserpantsnest/"

const serpent: CommunityData = {
  code: "theserpentsnest",
  inviteCode: "serpentsnest",
  name: "The Serpent's Nest",
  publicEventPages: true,
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ser-023`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#feead8",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[148px] h-[148px]",
      },
      inviteGate: {
        mobileLayout: "joinFirst",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[148px] h-[148px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#3e3b37]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['PalatinoRegular']",
      primaryButton:
        "bg-[#000000] border border-[#8d847b] px-[18px] py-[18px] !text-[#feead8] font-['PalatinoRegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#feead8",
      sideBarSeparator: "border-r-[1px] border-[#3e3b37]",
      separator: "border-[#3e3b37]",
      item: "font-['PalatinoRegular'] text-[16px] text-[#feead8] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#3e3b37] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8",
      titles: "text-[#feead8] font-['PalatinoRegular'] text-[26px] text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#b6aaa0] font-['MontserratRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#3e3b37]",
        sectionTitle:
          "text-[#feead8] font-['PalatinoRegular'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#feead8] font-['PalatinoRegular'] text-[16px] text-left leading-[120%]",
          subtitle:
            "text-[#b6aaa0] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#3e3b37]",
        sectionTitle:
          "text-[#feead8] font-['PalatinoRegular'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#feead8] font-['PalatinoRegular'] text-[16px] text-left leading-[120%] mt-2 sm:mt-0",
          subtitle:
            "text-[#b6aaa0] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mt-2",
          location:
            "text-[#b6aaa0] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mt-1",
          date: "text-[#b6aaa0] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#feead8] font-['PalatinoRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#feead8] font-['MontserratRegular'] text-[14px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#feead8] font-['PalatinoRegular'] text-[26px] text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#3e3b37]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#feead8] font-['PalatinoRegular'] text-[26px] text-left leading-[120%]",
        subtitle:
          "text-[#b6aaa0] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#8d847b] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#feead8] font-['PalatinoRegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#feead8]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#3e3b37]",
        header: "text-[#feead8] font-['PalatinoRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#feead8] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#3e3b37]",
        header: "text-[#feead8] font-['PalatinoRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#feead8] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#feead8",
        mapStrokeColor: "#feead800",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#feead8] font-['PalatinoRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#feead8] font-['MontserratRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#feead8] font-['PalatinoRegular'] text-[22px] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#8d847b] px-[16px] py-[16px] text-[#feead8] font-['PalatinoRegular'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#3e3b37] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#feead8] font-['PalatinoRegular'] text-[16px] text-left leading-[120%] mb-1",
          description:
            "text-[#b6aaa0] font-['MontserratRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#b6aaa0] font-['PalatinoRegular'] text-[16px] text-left leading-[120%]",
          quantity: "text-[#feead8] font-['PalatinoRegular'] text-[14px] text-left leading-[100%]",
          status: "text-[#b6aaa0] font-['PalatinoRegular'] text-[16px] text-left leading-[120%]",
          counterContainer:
            "bg-[#000000] border border-[#8d847b] px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#8d847b] px-[16px] py-[16px] text-[#feead8] font-['PalatinoRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#feead8",
        },
      },
    },
  },
}

export default serpent
